import React from "react";
import { Warning } from "@phosphor-icons/react";
import { needsTypoConfirm, suggestEmail } from "@/lib/emailTypos";

const BASE = "border border-black px-2 py-1 text-[10px] uppercase tracking-widest transition-colors duration-100";
const BTN = `${BASE} bg-white hover:bg-black hover:text-white`;
const PRIMARY = `${BASE} bg-black text-white hover:bg-zinc-800`;

// "Did you mean …?" under an email box. onUse(fixed) swaps it in; onConfirm() keeps what was typed.
export function EmailTypoHint({ email, confirmed, onUse, onConfirm, testId }) {
  if (!needsTypoConfirm(email, confirmed)) {
    return null;
  }
  const fixed = suggestEmail(email);
  return (
    <div role="alert" data-testid={testId} className="mt-2 border border-amber-700 bg-amber-50 px-3 py-2 text-xs text-amber-950">
      <div className="flex items-start gap-1.5">
        <Warning size={14} weight="fill" className="mt-0.5 shrink-0" />
        <span>Did you mean <strong data-testid={`${testId}-suggestion`}>{fixed}</strong>?</span>
      </div>
      <div className="mt-2 flex flex-wrap gap-2">
        <button type="button" onClick={() => onUse(fixed)} className={PRIMARY} data-testid={`${testId}-use`}>
          Use {fixed.split("@")[1]}
        </button>
        <button type="button" onClick={onConfirm} className={BTN} data-testid={`${testId}-keep`}>Yes, it&apos;s correct</button>
      </div>
      <div className="mt-1.5 text-[11px] text-amber-800">Fix it or confirm it to continue.</div>
    </div>
  );
}
